var React = require('react');

function SkipBack (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"01_Assets/Icon/UI/skip_back","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd"},[React.createElement("polygon",{"id":"Triangle-Copy","stroke":"#FFFFFF","strokeWidth":"2","transform":"translate(12.000000, 18.000000) scale(-1, 1) rotate(90.000000) translate(-12.000000, -18.000000) ","points":"12 14 21 22 3 22","key":0}),React.createElement("polygon",{"id":"Triangle-Copy-2","stroke":"#FFFFFF","strokeWidth":"2","transform":"translate(21.000000, 18.000000) scale(-1, 1) rotate(90.000000) translate(-21.000000, -18.000000) ","points":"21 14 30 22 12 22","key":1})]));
}

SkipBack.defaultProps = {"width":"32px","height":"36px","viewBox":"0 0 36 36","version":"1.1"};

module.exports = SkipBack;

SkipBack.default = SkipBack;
